<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.dictId ? (isEdit ? '编辑字典' : '查看字典') : '新增字典'" v-bind="$attrs"
    v-on="$listeners">
    <div class="edit-box flex-c-e"
      v-show="baseForm.dictId && baseForm.isSystem === '0'">
      <el-button v-if="hasPermi(['system:dict:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child" v-closeSelect>
      <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
        :disabled="!!(!isEdit && baseForm.dictId)" label-width="120px">
        <el-form-item class="half" label="字典代码" prop="dictCode">
          <el-input v-model.trim="dialogForm.dictCode" clearable placeholder="请输入字典代码" />
        </el-form-item>
        <el-form-item class="half" label="字典名称" prop="dictName">
          <el-input v-model.trim="dialogForm.dictName" clearable placeholder="请输入字典名称" />
        </el-form-item>
        <el-form-item class="all" label="备注" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.dictId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.dictId || isEdit">确 定</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import { dictApi } from "@/api"
export default {
  name: "DictDialog",
  props: {
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    // 配置数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    /** 检查是否已存在 */
    const checkDictCode = (rule, value, callback) => {
      const rex = /[A-Za-z_]+$/
      if (!rex.test(value)) {
        callback("字典代码只能为英文字母或下划线组成！")
        return
      }
      dictApi
        .judgeExist({ dictCode: value, dictId: this.baseForm.dictId })
        .then((data) => {
          if (data.validateResult) {
            callback()
          } else {
            callback(data.msg)
          }
        })
    }
    return {
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        dictName: [
          { required: true, message: "请输入字典名称", trigger: "blur" }
        ],
        dictCode: [
          { required: true, message: "请输入字典代码", trigger: "blur" },
          { validator: checkDictCode, trigger: "blur" }
        ]
      }
    }
  },
  watch: {
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.dialogForm = JSON.parse(JSON.stringify(this.baseForm))
    },
    // 重置表单
    resetForm() {
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate((valid) => {
        if (valid) {
          //更新
          if (this.dialogForm.dictId) {
            dictApi.updateItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("编辑字典成功")
              this.$emit("close")
              this.$emit("successs")
            })
          } else {
            //新增
            dictApi.createItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("新增字典成功")
              this.$emit("close")
              this.$emit("successs")
            })
          }
        }
      })
    }
  }
}
</script>
